import { createFileRoute } from "@tanstack/react-router";
import CalendarView from "@/components/operations/work-orders/calendar/calendar-view";

export const Route = createFileRoute(
  "/_authenticated/operations/work-orders/_list/calendar",
)({
  component: WorkOrdersCalendarPage,
});

function WorkOrdersCalendarPage() {
  return (
    <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
      <CalendarView />
    </div>
  );
}
